export const codePage1 = `
import { motion } from 'framer-motion'

const variantsScale = {
    initial: { scale : 0 },
    animate: { scale : 1 },
    exit: { scale : 0, transition : { duration : 0.1 } },
};

export const Layout = ({ children }) => {
 return (
    <motion.div
        key={activeTab} 
        initial="initial"
        animate="animate"
        exit="exit"
        variants={variantsScale}
        transition={{ duration: 1, ease : [0.22, 1, 0.36, 1] }}
    >
        {children}
    </motion.div>
 )
}

`